import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useLevitateTelephonyConfigurationMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async () => {
			const response = await userSession.webServiceHelper.callAsync(
				'account/features/texting/useLevitateTextingCampaignRegistration',
				'POST'
			);
			return response;
		},
		onError,
		onSuccess,
	});
}
